/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.directive('formElement', $compile => ({
    restrict:    'A',
    transclude:  true,
    templateUrl: 'directives/form-element/template.html',

    link(scope, element) {
        return scope.$watch(`[errors.${scope.field_name}, warnings.${scope.field_name}]`, function() {
            if (((scope.errors == null) || !angular.isObject(scope.errors)) &&
            ((scope.warnings == null) || !angular.isObject(scope.warnings))) { return; }

            if (((scope.errors != null ? scope.errors[scope.field_name] : undefined) != null) && angular.isObject(scope.errors)) {
            return element.addClass('has-error');
            } else if (((scope.warnings != null ? scope.warnings[scope.field_name] : undefined) != null) && angular.isObject(scope.warnings)) {
            return element.addClass('has-warning');
            } else { return element.removeClass('has-error has-warning'); }
        });
    },

    scope: {
        errors:     '=',
        warnings:   '=',
        field_name: '@fieldName'
    }
}));
